import React from 'react';
import { ChatUser } from '@my-game/shared-types';
import './UserList.css';

interface UserListProps {
  users: ChatUser[];
}

const UserList: React.FC<UserListProps> = ({ users }) => {
  return (
    <div className="user-list">
      <div className="user-list-header">
        <h3>Игроки в локации ({users.length})</h3>
      </div>
      <div className="user-list-content">
        {users.length === 0 ? (
          <div className="user-list-empty">Нет игроков в локации</div>
        ) : (
          users.map((user) => (
            <div key={user.characterId} className="user-item">
              <span className="user-status">●</span>
              <span className="user-nickname">{user.nickname}</span>
              <span className="user-level">[{user.level}]</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UserList;
